const SelectedLockerMarkerIcon = ({
  width = "16px",
  height = "16px",
  color = "#C00033",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 11 14"
    width={width}
    height={height}
  >
    <path
      fill={color}
      d="M5.5 0a5.5 5.5 0 0 0-4.22 9.03L5.5 14l4.22-4.98.17-.22a5.44 5.44 0 0 0-.5-7.19A5.5 5.5 0 0 0 5.5 0Zm2.1 5.85L5.5 8 3.4 5.85a1.4 1.4 0 0 1 .43-2.25 1.33 1.33 0 0 1 1.47.3l.2.2.2-.2a1.33 1.33 0 0 1 1.9 0 1.4 1.4 0 0 1 0 1.95Z"
    />
  </svg>
);

export default SelectedLockerMarkerIcon;
